import { Backdrop } from "@deligoo/ui"
import clsx from "clsx"
import { ReactNode } from "react"
import { createPortal } from "react-dom"

import cls from "./AsidePanel.module.scss"

type AsidePanelProps = {
  width?: number | string
  children: ReactNode
  className?: string
  handleClose: () => void
}

export const AsidePanel = ({ width, children, className, handleClose }: AsidePanelProps) => {
  return createPortal(
    <aside className={clsx(cls.asidePanel, className)} style={width ? { maxWidth: width } : undefined}>
      <Backdrop onClick={handleClose} style={{ zIndex: 1100 }} />
      {children}
    </aside>,
    document.body
  )
}
